import React, { useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addBasketItem } from '../redux/reducers/basketReducer';
import { PRODUCT_PAGES, ROUTES } from '../constants/routes';
import BookPreview from '../components/BookPreview';
import { BooksInAddind } from '../components/books_in_adding';
import { useScrollTop } from '../helpers/useScrollTop';

export const Certificates = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { query = {} } = useLocation();
  useScrollTop();
  const { basketItemId } = query;
  const [numberOfCopies, setNumberOfCopies] = useState(query.numberOfCopies || 1);

  const certificates = useSelector(state => state.common.productTypes.certificates);

  const addToBasket = variant => {
    dispatch(
      addBasketItem({
        numberOfCopies,
        images: [],
        type: '',
        orientation: '',
        size: variant.size,
        coverImages: [{ url: certificates[0].logo }],
        comment: '',
        productType: PRODUCT_PAGES.GIFT_CERTIFICATES,
        id: basketItemId || new Date().getTime(),
        productId: `${variant.productTypeId}-${variant.size}`,
        productTypeId: variant.productTypeId,
        price: variant.price,
        shilda: variant.shilda,
        cover: variant.cover,
      })
    );
    history.push(ROUTES.BASKET);
  };

  const priceModifier = useCallback(p => p * numberOfCopies, [numberOfCopies]);

  if (!certificates[0]) return null;
  return (
    <BookPreview
      item={certificates[0]}
      onSelectProduct={addToBasket}
      buttonText="Добавить в корзину"
      onBack={() => history.push(ROUTES.PORTAL)}
      priceModifier={priceModifier}
      extraItems={
        <>
          <p className="label">Количество сертификатов</p>
          <BooksInAddind
            numberOfCopies={numberOfCopies}
            handleChange={({ target }) => setNumberOfCopies(target.value)}
          />
        </>
      }
    />
  );
};
